import React from 'react';
import PropTypes from 'prop-types';

export function conversationShare(messages) {
    const size = role => messages.filter(m => m.role === role).reduce((sum, m) => sum + Array.from(m.content.replace(/\s/gu, '')).length, 0);
    const client = size('model'), counselor = size('user'), total = client + counselor;
    const clientPercent = total ? Math.round(client / total * 100) : null;
    return { client, counselor, clientPercent, counselorPercent: total ? 100 - clientPercent : null };
}

export default function SupervisorDashboard({ chat }) {
    const messages = chat?.messages || [];
    const share = conversationShare(messages);
    return <aside className="ai-supervisor-dashboard" aria-label="수퍼바이저 대시보드">
        <section className="ai-dashboard-metric" aria-labelledby="share-title">
            <h3 id="share-title">대화 점유율</h3><p className="ai-small">현재 대화의 공백 제외 글자 수 기준 · 발화 시간과는 다릅니다.</p>
            <div className="ai-share-bar" role="img" aria-label={share.clientPercent === null ? '아직 대화가 없습니다.' : `내담자 ${share.clientPercent}%, 상담자 ${share.counselorPercent}%`}>
                <span style={{ width: `${share.clientPercent || 0}%` }} /><span style={{ width: `${share.counselorPercent || 0}%` }} />
            </div>
            <div className="ai-share-labels"><span>내담자 <strong>{share.clientPercent === null ? '—' : `${share.clientPercent}%`}</strong><small>{share.client}자</small></span><span>상담자 <strong>{share.counselorPercent === null ? '—' : `${share.counselorPercent}%`}</strong><small>{share.counselor}자</small></span></div>
        </section>
    </aside>;
}
SupervisorDashboard.propTypes = { chat: PropTypes.object };
